import React, { useState, useEffect } from 'react';
import { Input } from '../../../common/Forms/Input/Input';
import { notify } from '../../../../assets/helpers/toast';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as schemas from '../../../../assets/schemas/schemas';
import { ActionButton, AltButton } from '../../../common/Buttons/Buttons';
import {
  paymentTypeOptions,
  paymentMethodsLimit,
  paymentMethods,
  paymentType as paymentTypeOption,
} from '../../../../assets/helpers/options';
import { productService } from '../../../../services/productService';
import { paymentsService } from '../../../../services/paymentsService';
import { stripeService } from '../../../../services/stripeService';
import { bancamigaService } from '../../../../services/bancamigaService';
import safePayment from '../../../../images/safePayment.svg';
import { salesRoles } from '../../../../assets/helpers/roles';
import {
  StripeModal,
  NewPaymentModal,
  CashBackComponent,
} from '../LandingComponents/LandingModals';
import { CashbackModal } from '../LandingComponents/CashbackModal';
import {
  MultiplePaymentsTable,
  NextQuotasTable,
} from '../../../common/Tables/Tables';
import {
  multiplePaymentsTableHeader,
  nextQuotaTableHeader,
} from '../../../../assets/helpers/tables';
import { IGTFPaymentModal } from '../../../common/Modals/Modals';
import './LandingForms.scss';
import { membershipService } from '../../../../services/membershipService';
import { LoadSpinner } from '../../../common/LoadSpinner/LoadSpinner';
import {
  secondQuotaTime,
  casheaQuotaTime,
} from '../../../../assets/helpers/variables';
import {
  NaNtoNumber,
  filterParams,
  filterById,
  filterOptionById,
  // filterOption,
  returnIGTF,
  isPaymentMethodZelleOrPaypal,
  validateReferenceLength,
  validatePaymentDifference,
  sortPublicPaymentMethods,
  validateInmediateDebit,
  immediateDebitLastELement,
  validateAndSet,
  validateAmount0,
  validatePMCashbackData,
  displayMembershipCode,
  capitalize,
} from '../../../../assets/helpers/funciones';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import authService from '../../../../services/authService';
import { MultipleVehiclesTable } from '../MultipleAfiliationComponents/MultipleVehiclesTable';
import { multipleVehiclesTableHeader } from '../../../../assets/helpers/tables';
import { cashReceiverService } from '../../../../services/cashReceiverService';
import { useCasheaPayment } from '../../../../hooks/payments/useCasheaPayment';
import { casheaLinkService } from '../../../../services/casheaLinkService';
import { CasheaLinkFlow } from './CasheaLink/CasheaLinkFlow';

export const PlanPurchaseForm = React.memo((props) => {
  const {
    setcurentStep,
    curentStep,
    dollarRate,
    dollarRateByDate,
    membership,
    selectedMembership,
    membershipList,
    paymentDate,
    isPublicLanding,
  } = props;

  const t = useTranslation();
  const { saleChannel } = useParams();
  const [popupWindow, setPopupWindow] = useState(null);
  const [paymemtMethodOptions, setPaymemtMethodOptions] = useState([]);
  const [filteredMethods, setFilteredMethods] = useState([]);
  const [errorsDropzone, setErrorsDropzone] = useState({});
  const [fileUploaded, setFileUploaded] = useState([]);
  const [showErrorAPI, setShowErrorAPI] = useState(false);
  const [showIGTFPaymentModal, setShowIGTFPaymentModal] = useState({
    isOpen: false,
    method: '',
    amount1: 0,
  });
  const [stripeModal, setStripeModal] = useState({
    isOpen: false,
    methods: [],
  });
  const [clientSecret, setClientSecret] = useState('');
  const [cashBackImage, setCashBackImage] = useState([]);
  const [selectedMethod, setSelectedMethod] = useState('');
  const [paymentTypeVar, setPaymentTypeVar] = useState([]);
  const [paymentMethodsQuantity, setPaymentMethodsQuantity] = useState([]);
  const [cashReceiverOptions, setCashReceiverOptions] = useState([]);
  const [cashbackModal, setCashbackModal] = useState({
    isOpen: false,
  });

  const [payment, setPayment] = useState({
    amount: 1,
    amountBsS: 1,
    methods: [],
    reference: '',
    owner: '',
  });

  const rate = authService.getUser() ? dollarRateByDate : dollarRate;
  const [isLoading, setIsloading] = useState(false);

  const getPaymentsData = (file, index) => {
    if (
      paymemtMethodOptions?.length > 0 &&
      [
        paymentMethods?.TRANSFERENCIA_BANESCO,
        paymentMethods?.TRANSFERENCIA_BANCAMIGA,
        paymentMethods?.TRANSFERENCIA_BANPLUS,
        paymentMethods?.TRANSFERENCIA_BNC,
        paymentMethods?.TRANSFERENCIA_MERCANTIL,
        paymentMethods?.PAGO_MÓVIL_BNC,
        paymentMethods?.PAGO_MOVIL_BANPLUS,
        paymentMethods?.PAGO_MÓVIL_BANCAMIGA,
        paymentMethods?.PAGO_MÓVIL_BANESCO,
        paymentMethods?.PAGO_MÓVIL_MERCANTIL,
        paymentMethods?.PUNTO_DE_VENTA,
      ].includes(
        filterById(paymemtMethodOptions, watch(`method${index}`))?.name
      )
    ) {
      const formData = new FormData();
      formData.append('file', file);
      setIsloading(true);
      membershipService
        .getPaymentsData(formData)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            const res = response?.data?.[0]?.data;
            if (
              paymemtMethodOptions?.length > 0 &&
              [
                paymentMethods?.TRANSFERENCIA_BANESCO,
                paymentMethods?.TRANSFERENCIA_BANCAMIGA,
                paymentMethods?.TRANSFERENCIA_BANPLUS,
                paymentMethods?.TRANSFERENCIA_BNC,
                paymentMethods?.TRANSFERENCIA_MERCANTIL,
                paymentMethods?.PAGO_MÓVIL_BNC,
                paymentMethods?.PAGO_MOVIL_BANPLUS,
                paymentMethods?.PAGO_MÓVIL_BANESCO,
                paymentMethods?.PAGO_MÓVIL_MERCANTIL,
                paymentMethods?.PUNTO_DE_VENTA,
              ].includes(
                filterById(paymemtMethodOptions, watch(`method${index}`))?.name
              )
            ) {
              const ref =
                res?.operation_id === null ||
                  res?.operation_id === '' ||
                  [paymentMethods?.PUNTO_DE_VENTA].includes(
                    filterById(paymemtMethodOptions, watch(`method${index}`))
                      ?.name
                  )
                  ? res?.reference_id
                  : res?.operation_id;
              validateAndSet(`reference${index}`, ref, setValue, watch);
              setPayment((prevState) => {
                return {
                  ...prevState,
                  reference: ref,
                };
              });

              setIsloading(false);
            } else if (
              paymemtMethodOptions?.length > 0 &&
              [paymentMethods?.PAGO_MÓVIL_BANCAMIGA].includes(
                filterById(paymemtMethodOptions, watch(`method${index}`))?.name
              )
            ) {
              const ref =
                res?.operation_id === null || res?.operation_id === ''
                  ? res?.reference_id
                  : res?.operation_id;
              validateAndSet(`reference${index}`, ref, setValue, watch);
              validateAndSet(
                `date${index}`,
                new Date(moment(res?.date).endOf('day')),
                setValue,
                watch
              );

              // const normalizeBankName = (value = '') =>
              //   value
              //     .normalize('NFD') // separa acentos
              //     .replace(/[\u0300-\u036f]/g, '') // quita acentos
              //     .replace(/[.,]/g, '') // quita comas/puntos
              //     .toLowerCase()
              //     .replace(/\s+/g, ' ')
              //     .trim();

              // if (res?.bank_name) {
              //   const target = normalizeBankName(res.bank_name);
              //   const bankMatch = banksOptions.find(
              //     (b) =>
              //       normalizeBankName(b.name).includes(target) ||
              //       target.includes(normalizeBankName(b.name))
              //   );
              //   validateAndSet(
              //     `bank${index}`,
              //     bankMatch ? bankMatch._id : res.bank_name, // ojo: banksOptions tiene _id, no code
              //     setValue,
              //     watch
              //   );
              // }

              setPayment((prevState) => {
                return {
                  ...prevState,
                  reference: ref,
                };
              });
              setIsloading(false);
            } else {
              setIsloading(false);
              notify(`${response.message}` || 'error', 'error');
            }
          } else {
            setIsloading(false);
            notify(`${response.message}` || 'error', 'error');
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    } else {
      setIsloading(false);
      return true;
    }
  };

  const handleDrop = (event, index) => {
    let file = '';
    // File added on drop
    if (event?.dataTransfer?.files) {
      file = Array?.from(event?.dataTransfer?.files)[0];
    }

    let maxWeight = 5; //Peso en MB

    // File added on Click
    if (event?.target?.files?.length > 0) {
      file = event?.target?.files[0];
    }

    if (
      !['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'].includes(
        file.type
      )
    ) {
      notify('Agregar un formato valido de imagen', 'error');
      return null;
    }
    if (file.size * 0.000001 > maxWeight) {
      notify(`La imagen no debe superar los ${maxWeight} MB`, 'error');
    }
    setCashBackImage((prevState) => {
      return {
        ...prevState,
        [`image${index}`]: file,
      };
    });
  };

  const removeFile = (index) => {
    setCashBackImage((prevState) => {
      return {
        ...prevState,
        [`image${index}`]: '',
      };
    });
  };

  const handleCashbackModal = (index, isValid) => {
    setCashbackModal((prevState) => {
      return {
        ...prevState,
        isOpen: !cashbackModal.isOpen,
        paymentNumber: index >= 0 ? index : '',
        amount: parseFloat(watch(`returnedAmount${index}`)),
        amountBsS: parseFloat(watch(`returnedAmountBsS${index}`)),
      };
    });

    if (!isValid) {
      setValue(`cashBackphone${index}`, '');
      setValue(`cashBackbank${index}`, '');
      setValue(`cashBackIdentificationType${index}`, '');
      setValue(`cashBackIdentification${index}`, '');
    }
  };

  const saveCashbackData = () => {
    let isValid = true;

    const dataArray = [
      'cashBackphone',
      'cashBackbank',
      'cashBackIdentificationType',
      'cashBackIdentification',
    ];

    for (let i = 0; i < dataArray.length; i++) {
      setError(`${dataArray[i]}${cashbackModal.paymentNumber}`, {
        type: 'custom',
        message: '',
      });

      if (watch(`cashBackphone${cashbackModal.paymentNumber}`)?.length !== 10) {
        setError(`cashBackphone${cashbackModal.paymentNumber}`, {
          type: 'custom',
          message: 'Ingrese un numero de telefono valido: Ejemplo: 4143579865',
        });
        isValid = false;
        return;
      }

      if (!watch(`${dataArray[i]}${cashbackModal.paymentNumber}`)) {
        setError(`${dataArray[i]}${cashbackModal.paymentNumber}`, {
          type: 'custom',
          message: 'Obligatorio',
        });
        isValid = false;
      }
    }

    if (isValid) {
      handleCashbackModal(0, isValid);
    }
  };

  const prelaodTest = () => {
    setValue('paymentType', 'De contado');
    setValue('paymentMethodsQuantity', '1');
    selectUniquePayment();
    setValue('method0', '646955f7fccc5f07cd2b8d50');
    setValue('paid0', 500);
    setValue('returnedMethod0', '656974241d4975ed691d30e0');

    setPayment((prevState) => {
      return {
        ...prevState,
        isOpen: true,
        paymentNumber: 0,
        reference: 'prueba',
        owner: '',
      };
    });
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    watch,
    control,
    setError,
  } = useForm({
    resolver: yupResolver(schemas.planPurchase(t)),
  });

  // Inicial 0 con Cashea solo aplica al flujo interno de ventas;
  // el flujo público arma la inicial desde el popup de Cashea
  const { isZeroInitialCashea, appendCasheaZeroInitial } = useCasheaPayment({
    watch,
    enabled: Boolean(authService.getUser()),
  });

  const validatePaymentOptions = () => {
    let user = localStorage.getItem('user');
    user = JSON.parse(user);
    let array = [...paymentTypeOptions];
    if (
      ![
        salesRoles.SALES_DEVELOPER,
        salesRoles.SALES_ADMIN,
        salesRoles.SALES_SUPERVISOR,
        salesRoles.SALES_HUNTER,
        salesRoles.SALES_FARMER,
        salesRoles.SALES_COUNTER,
        salesRoles.SALES_MARKETING,
        salesRoles.SALES_ADMIN_AUX,
        salesRoles.EVENTS,
        salesRoles.SALES_KEY_ACCOUNTS,
      ].includes(user?.roles[0]?.code)
    ) {
      array = array.filter(
        (a) =>
          ![
            paymentTypeOption?.PENDING,
            paymentTypeOption?.COURTESY,
            paymentTypeOption?.FINANCIADO,
          ].includes(a?._id)
      );
    }

    if (
      [
        salesRoles.SALES_DEVELOPER,
        salesRoles.SALES_ADMIN,
        salesRoles.SALES_HUNTER,
        salesRoles.SALES_FARMER,
        salesRoles.SALES_COUNTER,
        salesRoles.EVENTS,
        salesRoles.SALES_KEY_ACCOUNTS,
      ].includes(user?.roles[0]?.code) ||
      !user
    ) {
      array?.push({
        _id: paymentTypeOption?.CASHEA,
        name: 'Cashea',
      });
    }

    // Cashea Link solo está disponible en el Módulo de Asesores (usuario logueado)
    if (isPublicLanding) {
      array?.push({
        _id: paymentTypeOption?.CASHEA_LINK,
        name: 'Cashea Link',
      });
    }

    // No Pending payment for multuple affiliations
    if (membershipList && membershipList.length > 1) {
      array = array.filter((a) => a._id !== paymentTypeOption?.PENDING);
    }

    if (!isPublicLanding) { 
      const newArray = array.filter((a) => a._id !== paymentTypeOption?.VENFLOW);
      array = newArray;
    }

    setPaymentTypeVar(array);

    let methods = paymentMethodsLimit;
    if (!authService?.getUser()) {
      methods = paymentMethodsLimit?.filter((p) => [1, 2].includes(p?._id));
    }
    setPaymentMethodsQuantity(methods);
  };

  // Validate if all payments were made via TDC
  const paymentsWithTDC = (stripeId) => {
    // Si esta loggeado no pasas por el proceso regular de pago de TCD
    if (authService?.getUser()) {
      return false;
    }

    let paymenTDCounter = 0;
    let paymentMethodsQuantity = parseInt(getValues('paymentMethodsQuantity'));
    for (let i = 0; i < paymentMethodsQuantity; i++) {
      if (stripeId?._id === watch(`method${i}`)) {
        paymenTDCounter = paymenTDCounter + 1;
      }
    }
    if (paymenTDCounter === paymentMethodsQuantity) {
      // Save data to local storage and jump to next step
      // updateMembershipStatus(membership?._id);
      // setcurentStep(curentStep + 1);
      // return true;
      return false;
    } else {
      return false;
    }
  };

  const storeData = (params) => {
    for (let i = 0; i < params?.payments?.length; i++) {
      params.payments[i].methodName = paymemtMethodOptions?.filter(
        (p) => p?._id === params?.payments[i]?.method
      )[0]?.name;
      params.payments[i].currency = paymemtMethodOptions?.filter(
        (p) => p?._id === params?.payments[i]?.method
      )[0]?.currency;
    }

    sessionStorage.setItem('payment', JSON.stringify(params));
  };

  const handleGenericPaymentMethods = (index) => {
    setValue(`date${index}`, '');
    setValue(`bank${index}`, '');
    setValue(`phone${index}`, '');
    setValue(`reference${index}`, '');
    setValue(`transactionBatch${index}`, '');

    let selectedMethod = filterById(
      paymemtMethodOptions,
      watch('paymentOption')
    );
    setValue(`method${index}`, selectedMethod?._id);
  };

  let loadPaymentForms = (params) => {
    let [stripeId] = paymemtMethodOptions?.filter(
      (p) => p?.name === paymentMethods?.STRIPE
    );

    let payments = [];
    let allPayments = [];
    // Con inicial 0 en Cashea no se construyen objetos de pago
    const paymentFormsQuantity = isZeroInitialCashea
      ? 0
      : parseInt(getValues('paymentMethodsQuantity'));
    // lOOP through every payment method
    for (let i = 0; i < paymentFormsQuantity; i++) {
      let data = {
        method: params[`method` + i.toString()],
        reference: params[`reference` + i.toString()],
        transactionBatch: params[`transactionBatch` + i.toString()],
        referenceCashea: watch('referenceCashea'),
        amountIGTF: parseFloat(params[`IGTF` + i.toString()]),
        amount: parseFloat(params[`amount` + i.toString()]),
        amountBsS: parseFloat(params[`finalAmountBsS` + i.toString()]),
        bank: params[`bank` + i.toString()],
        phone: params[`phone` + i.toString()],
        date: params[`date` + i.toString()],
        identificationType: watch(`identificationType` + i.toString()),
        identification: watch(`identification` + i.toString()),
        observation: params[`observation` + i.toString()],
      };

      allPayments.push(filterParams(data));

      let data2 = {};
      data2.method = params[`method` + i.toString()];
      data2.amountBsS = params[`finalAmountBsS` + i.toString()];
      data2.reference = params[`reference` + i.toString()];
      data2.transactionBatch = params[`transactionBatch` + i.toString()];
      data2.referenceCashea = watch('referenceCashea');
      data2.owner = params[`owner` + i.toString()];
      data2.igtfAmount = parseFloat(params[`IGTF` + i.toString()]);
      data2.bank = params[`bank` + i.toString()];
      data2.phone = params[`phone` + i.toString()];
      data2.date = params[`date` + i.toString()] || paymentDate;
      data2.observation = params[`observation` + i.toString()];

      data2.amount = parseFloat(params[`amount` + i.toString()]);
      if (
        [paymentMethods?.DEBITO_INMEDIATO].includes(
          filterById(paymemtMethodOptions, params[`method` + i.toString()])
            ?.name
        )
      ) {
        data2.identificationType = params[`identificationType` + i.toString()];
        data2.identification = params[`identification` + i.toString()];
        data2.otp = params[`otp` + i.toString()];
      }
      if (
        [paymentMethods?.C2P_BANCAMIGA].includes(
          filterById(paymemtMethodOptions, params[`method` + i.toString()])
            ?.name
        )
      ) {
        data2.identificationType = params[`identificationType`];
        data2.identification = params[`identification`];
        data2.otp = params[`otp`];
      }
      if (
        [paymentMethods?.NATIONAL_TDC].includes(
          filterById(paymemtMethodOptions, params[`method` + i.toString()])
            ?.name
        )
      ) {
        data2.identification = params[`identification` + i.toString()];
        data2.cardCvc = params[`cvc` + i.toString()];
        data2.creditCard = params[`card` + i.toString()];
        const date = params[`cardDate` + i.toString()].split('/');
        data2.cardMonth = date[0];
        data2.cardYear = date[1];
      }

      if (
        [
          paymentMethods?.CASH_USD,
          paymentMethods?.CASH_BS,
          paymentMethods?.CASH_EUR,
          paymentMethods?.PUNTO_DE_VENTA,
        ].includes(
          filterById(paymemtMethodOptions, params[`method` + i.toString()])
            ?.name
        )
      ) {
        data2.cashReceiver = params[`cashReceiver` + i.toString()];
      }

      payments?.push({
        ...data2,
      });
    }

    // "REmove unwanted params from JSON"
    let words = [
      'method',
      'reference',
      'transactionBatch',
      'amount',
      'observation',
      'identification',
      'identificationType',
      'amountIGTF',
      'amountBsS',
      'paymentMethod',
      'bank',
      'phone',
      'date',
    ];
    for (const key in params) {
      for (var i = 0, ln = words?.length; i < ln; i++) {
        if (key.indexOf(words[i]) !== -1) {
          delete params[key];
        }
      }
    }

    params.payments = immediateDebitLastELement(payments);
    params.allPayments = immediateDebitLastELement(allPayments);
    storeData(params);
    const tdc = paymentsWithTDC(stripeId);

    if (tdc) {
      return null;
    } else {
      return params;
    }
  };

  const updateMembershipStatus = (membershipId) => {
    setIsloading(true);
    membershipService
      .updateMembershipStatus(membershipId, {
        siblingMemberships: membership?.siblingMemberships,
      })
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          setcurentStep(curentStep + 1);
          setIsloading(false);
        } else {
          setIsloading(false);
          notify(`${response.message}`, 'error');
        }
      })
      .catch((error) => {
        setIsloading(false);
      });
  };

  const getCashReceivers = () => {
    cashReceiverService
      .getCashReceivers()
      .then((response) => {
        if (response.status === 200) {
          setCashReceiverOptions(response?.data?.cashReceivers);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch((e) => {
        console.log('Error trayendo las cajas de efectivo', e);
      });
  };

  const specialPayment = () => {
    const formData = new FormData();

    formData.append('paymentType', watch('paymentType'));
    formData.append('membership', membership?._id);

    if (membership?.siblingMemberships?.length > 0) {
      for (let i = 0; i < membership?.siblingMemberships.length; i++) {
        formData.append(
          `siblingMemberships[${i}]`,
          membership?.siblingMemberships[i]
        );
      }
    }

    if (!isLoading) {
      setIsloading(true);
      paymentsService
        .createMembershipPayment(formData)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            updateMembershipStatus(membership?._id);
          } else {
            setIsloading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  };

  const validateCashBackTotal = () => {
    let cashbackMethodsQuantity = parseFloat(watch('cashbackMethodsQuantity'));
    let amountReturned = parseFloat(watch(`amountReturned`)).toFixed(2);
    let total = 0;
    for (let i = 0; i < cashbackMethodsQuantity; i++) {
      total = total + parseFloat(watch(`returnedAmount${i}`));
    }

    if (parseFloat(total?.toFixed(2)) !== parseFloat(amountReturned)) {
      notify(
        'La suma de los montos debe ser igual al montoa a entregar',
        'error'
      );
      return false;
    } else {
      return true;
    }
  };

  const validateCashBackImages = () => {
    let cashbackMethodsQuantity = parseFloat(watch('cashbackMethodsQuantity'));
    let canPost = true;

    setErrorsDropzone((prevState) => {
      return {
        ...prevState,
        error1: false,
        error2: false,
        error3: false,
      };
    });

    for (let i = 0; i < cashbackMethodsQuantity; i++) {
      const requiredMetods = paymemtMethodOptions?.filter((method) =>
        [
          paymentMethods?.CASH_BS,
          paymentMethods?.CASH_EUR,
          paymentMethods?.CASH_USD,
        ]?.includes(method?.name)
      );
      const method = filterOptionById(
        requiredMetods,
        watch('returnedMethod' + i)
      );

      if (method && !watch(`returnedReference${i}`)) {
        setError(`returnedReference${i}`, {
          type: 'custom',
          message: 'Obligatorio',
        });
        canPost = false;
      }

      if (!cashBackImage[`image${i}`] && method) {
        notify(
          `Adjunte todos los comprobantes de pago de ${method?.name}`,
          'error'
        );
        canPost = false;
        setErrorsDropzone((prevState) => {
          return {
            ...prevState,
            [`error${i}`]: true,
          };
        });
      }
    }
    return canPost;
  };

  const PAYMENT_VALIDATION_ERROR_MESSAGE =
    'No pudimos validar el pago, por favor revisa los datos ingresados';

  const handlePaymentValidationError = (response) => {
    setShowErrorAPI(true);
    setIsloading(false);
    notify(response?.data?.message || response?.message || PAYMENT_VALIDATION_ERROR_MESSAGE, 'error');
  };

  const handlePaymentError = (response) => {
    setIsloading(false);
    notify(response?.data?.message || response?.message || 'Error al realizar el pago', 'error');
  };

  const onSubmit = handleSubmit(async (data) => {
    let dataToPost = { ...data };
    delete dataToPost?.finalPrice;
    delete dataToPost?.finalPriceInBsS;
    delete dataToPost?.paymentOption;
    delete dataToPost?.selectedMembership;
    delete dataToPost?.numCasheaDues;

    dataToPost.membership = membership?._id;
    dataToPost = loadPaymentForms(dataToPost);

    if (!dataToPost) {
      return null;
    }

    let fileToPost = appendFile(dataToPost);

    if (!isLoading && fileToPost) {
      if (!authService.getUser()) {
        window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
        const dataLayer = {
          event: 'add_payment_info',
          ecommerce: {
            currency: 'USD',
            value: dataToPost?.billAmount,
            coupon: membership?.codigo,
            payment_type: dataToPost?.paymentType,
            payment_methods_quantity: `${dataToPost.allPayments.length} Método de pago`,
            payment_method:
              dataToPost?.payments[0]?.methodName +
              (dataToPost?.payments[1]?.methodName
                ? `,${dataToPost?.payments[1]?.methodName}`
                : ''),
            items: [
              {
                item_id: selectedMembership?._id,
                item_name: selectedMembership?.code,
                plan_category: `Planes de ${membership?.class}`,
                discount:
                  selectedMembership?.discountByCode ||
                  selectedMembership?.discountByGiftCard,
                coupon: membership?.codigo,
                payment_method_1: dataToPost?.payments[0]?.methodName || '',
                payment_method_1_amount:
                  dataToPost?.payments[0]?.amount +
                  dataToPost?.payments[0]?.igtfAmount || 0,
                payment_method_2: dataToPost?.payments[1]?.methodName || '',
                payment_method_2_amount:
                  dataToPost?.payments[1]?.amount +
                  dataToPost?.payments[1]?.igtfAmount || 0,
                item_category: selectedMembership?.code,
                price: dataToPost?.billAmount,
                quantity: 1,
              },
            ],
          },
          // If logged In
        };
        const dataLayer2 = {
          event: 'purchase',
          ecommerce: {
            transaction_id: membership?.membershipId || '',
            currency: 'USD',
            value: membership?.priceInfo?.finalPrice || 0,
            coupon: membership?.codigo,
            tax:
              dataToPost?.payments[0]?.igtfAmount +
              dataToPost?.payments[1]?.igtfAmount,
            items: [
              {
                item_id: selectedMembership?._id,
                item_name: selectedMembership?.code,
                discount:
                  selectedMembership?.discountByCode ||
                  selectedMembership?.discountByGiftCard,
                coupon: membership?.codigo,
                item_category: selectedMembership?.code,
                plan_category: `Planes de ${membership?.class}`,
                payment_method_1: dataToPost?.payments[0]?.methodName || '',
                payment_method_1_amount:
                  dataToPost?.payments[0]?.amount +
                  dataToPost?.payments[0]?.igtfAmount || 0,
                payment_method_2: dataToPost?.payments[1]?.methodName || '',
                payment_method_2_amount:
                  dataToPost?.payments[1]?.amount +
                  dataToPost?.payments[1]?.igtfAmount || 0,
                price: dataToPost?.billAmount,
                quantity: 1,
              },
            ],
          },
          // If logged In
        };

        const fb1 = {
          content_ids: [selectedMembership?._id],
          content_name: selectedMembership?.code,
          content_category: selectedMembership?.code,
          plan_category: `Planes de ${membership?.class}`,
          content_type: 'product',
          currency: 'USD',
          value: membership?.priceInfo?.finalPrice || 0,
        };

        const fb2 = {
          content_ids: [selectedMembership?._id],
          content_name: selectedMembership?.code,
          content_category: selectedMembership?.code,
          plan_category: `Planes de ${membership?.class}`,
          content_type: 'product',
          currency: 'USD',
          value: membership?.priceInfo?.finalPrice || 0,
          num_items: 1,
        };

        window.fbq('track', 'AddPaymentInfo', fb1);
        window.fbq('track', 'Purchase', fb2);

        window.dataLayer.push(dataLayer);
        window.dataLayer.push(dataLayer2);
      }

      if (!isZeroInitialCashea && !validateAmount0(data, notify)) {
        return null;
      }

      setIsloading(true);
      paymentsService
        .createMembershipPayment(fileToPost)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            updateMembershipStatus(membership?._id);
            // setIsloading(false);
          }
          else if ([400].includes(response.status) && response?.data?.message === PAYMENT_VALIDATION_ERROR_MESSAGE) {
            handlePaymentValidationError(response);
          }
          else {
            handlePaymentError(response);
          }
        })
        .catch((error) => {
          setIsloading(false);
          notify(`ERROR al realizar el pago`, 'error');
        });
    }
  });

  const appendFile = (data) => {
    const formData = new FormData();
    formData.append('membership', data?.membership);
    formData.append('paymentType', data?.paymentType);
    if (membership?.siblingMemberships.length > 0) {
      for (let i = 0; i < membership?.siblingMemberships.length; i++) {
        formData.append(
          `siblingMemberships[${i}]`,
          membership?.siblingMemberships[i]
        );
      }
    }

    for (var i = 0; i < data?.payments?.length; i++) {
      if (
        [
          paymentMethods?.CASH_USD,
          paymentMethods?.CASH_BS,
          paymentMethods?.CASH_EUR,
          paymentMethods?.PUNTO_DE_VENTA,
        ].includes(
          filterById(paymemtMethodOptions, data?.payments[i]?.method)?.name
        )
      ) {
        formData.append(
          `payments[${i}][cashReceiver]`,
          data?.payments[i]?.cashReceiver
        );
      }

      formData.append(`payments[${i}][method]`, data?.payments[i]?.method);
      if (data?.payments[i]?.observation) {
        formData.append(
          `payments[${i}][observation]`,
          data?.payments[i]?.observation
        );
      }
      formData.append(`payments[${i}][amount]`, data?.payments[i]?.amount);
      formData.append(
        `payments[${i}][amountBsS]`,
        data?.payments[i]?.amountBsS
      );
      formData.append(
        `payments[${i}][igtfAmount]`,
        data?.payments[i]?.igtfAmount
      );
      formData.append(
        `payments[${i}][igtf]`,
        data?.payments[i]?.igtfAmount ? true : false
      );
      if (data?.payments[i]?.bank) {
        formData.append(`payments[${i}][bank]`, data?.payments[i]?.bank);
      }
      if (data?.payments[i]?.phone && data?.payments[i]?.phone !== undefined) {
        formData.append(`payments[${i}][phone]`, data?.payments[i]?.phone);
      }
      // Send the flag if the payment has image or not
      formData.append(
        `payments[${i}][hasEvidence]`,
        fileUploaded[i]?.name ? true : false
      );

      if (fileUploaded[i]?.name) {
        formData.append(`paymentEvidence`, fileUploaded[i]);
      }

      formData.append(
        `payments[${i}][date]`,
        data?.payments[i]?.date
          ? moment(data.payments[i].date).format('YYYY-MM-DD')
          : moment(membership?.createdAt).format('YYYY-MM-DD')
      );

      if (
        data?.payments[i]?.reference &&
        data?.payments[i]?.reference.trim() !== ''
      ) {
        formData.append(
          `payments[${i}][reference]`,
          data?.payments[i]?.reference
        );
      }
      if (
        data?.payments[i]?.transactionBatch !== undefined &&
        data?.payments[i]?.transactionBatch !== ''
      ) {
        formData.append(
          `payments[${i}][transactionBatch]`,
          data?.payments[i]?.transactionBatch
        );
      }

      if (showErrorAPI && watch(`skipApiValidationError${i}`)) {
        formData.append(
          `payments[${i}][skipApiValidationError]`,
          watch(`skipApiValidationError${i}`)
        );
      }

      if (
        [paymentMethods?.C2P_BANCAMIGA].includes(
          filterById(paymemtMethodOptions, data?.payments[i]?.method)?.name
        )
      ) {
        formData.append(
          `payments[${i}][identificationType]`,
          data?.payments[i]?.identificationType
        );
        formData.append(
          `payments[${i}][identification]`,
          data?.payments[i]?.identification
        );
        formData.append(`payments[${i}][otp]`, data?.payments[i]?.otp);
      }

      if (
        [paymentMethods?.DEBITO_INMEDIATO].includes(
          filterById(paymemtMethodOptions, data?.payments[i]?.method)?.name
        )
      ) {
        formData.append(
          `payments[${i}][identificationType]`,
          data?.payments[i]?.identificationType
        );
        formData.append(
          `payments[${i}][identification]`,
          data?.payments[i]?.identification
        );
        formData.append(`payments[${i}][concept]`, `Pago Directo`);
        formData.append(`payments[${i}][otp]`, data?.payments[i]?.otp);
      }

      if (
        [paymentMethods?.NATIONAL_TDC].includes(
          filterById(paymemtMethodOptions, data?.payments[i]?.method)?.name
        )
      ) {
        formData.append(
          `payments[${i}][identification]`,
          data?.payments[i]?.identification
        );
        formData.append(`payments[${i}][cardCvc]`, data?.payments[i]?.cardCvc);
        formData.append(
          `payments[${i}][creditCard]`,
          data?.payments[i]?.creditCard
        );
        formData.append(
          `payments[${i}][cardMonth]`,
          data?.payments[i]?.cardMonth
        );
        formData.append(
          `payments[${i}][cardYear]`,
          data?.payments[i]?.cardYear
        );
      }

      if ([paymentTypeOption?.CASHEA].includes(data?.paymentType)) {
        formData.append(
          `payments[${i}][referenceCashea]`,
          data?.payments[i]?.referenceCashea
        );
      }
      if (
        isPaymentMethodZelleOrPaypal(
          data?.payments[i]?.method,
          paymemtMethodOptions
        )
      ) {
        // for zelle payments
        formData.append(`payments[${i}][accHolder]`, data?.payments[i]?.owner);
      }
    }

    if ([paymentTypeOption?.CASHEA].includes(data?.paymentType)) {
      // Add one because the BE expects paymentDues (initial + quotas are all payment dues)
      formData.append(
        `numCasheaDues`,
        parseFloat(watch('numCasheaDues')) + 1 || 4
      );
    }

    if (isZeroInitialCashea) {
      appendCasheaZeroInitial(formData);
    }

    if (parseFloat(watch('cashbackMethodsQuantity')) > 0) {
      // Validate the total of the cashback
      // Validate that all images are up
      if (!validateCashBackTotal() || !validateCashBackImages()) {
        return null;
      }

      // Adjuntar valores de vuelto
      for (let j = 0; j < parseFloat(watch('cashbackMethodsQuantity')); j++) {
        formData.append(`paymentChanges[${j}][paid]`, data[`paid`]);
        formData.append(
          `paymentChanges[${j}][method]`,
          data[`returnedMethod${j}`]
        );
        formData.append(
          `paymentChanges[${j}][amount]`,
          data[`returnedAmount${j}`]
        );
        formData.append(
          `paymentChanges[${j}][amountBsS]`,
          data[`returnedAmountBsS${j}`]
        );
        if (data[`returnedReference${j}`]) {
          formData.append(
            `paymentChanges[${j}][ref]`,
            data[`returnedReference${j}`]
          );
        }
        formData.append(
          `paymentChanges[${j}][hasEvidence]`,
          data[`returnedReference${j}`] ? true : false
        );
        if (watch(`observation${j}`)) {
          formData.append(
            `paymentChanges[${j}][observation]`,
            watch(`observation${j}`)
          );
        }
        if (
          !validatePMCashbackData(
            filterById(paymemtMethodOptions, data[`returnedMethod${j}`]),
            watch,
            j
          )
        ) {
          return '';
        }
        if (watch(`cashBackphone${j}`)) {
          formData.append(
            `paymentChanges[${j}][phone]`,
            watch(`cashBackphone${j}`)
          );
          formData.append(
            `paymentChanges[${j}][bank]`,
            watch(`cashBackbank${j}`)
          );
          formData.append(
            `paymentChanges[${j}][identificationType]`,
            watch(`cashBackIdentificationType${j}`)
          );
          formData.append(
            `paymentChanges[${j}][identification]`,
            watch(`cashBackIdentification${j}`)
          );
        }
        if (cashBackImage[`image${j}`]) {
          formData.append(`paymentChangeEvidence`, cashBackImage[`image${j}`]);
        }
      }
    }

    if (
      !authService.getUser() &&
      data?.paymentType === paymentTypeOption?.CASHEA
    ) {
      formData.append(`casheaOrderId`, data?.casheaOrderId);
      formData.append(`casheaDownPayment`, data?.casheaDownPayment);
      formData.append(`casheaParentOrderId`, data?.casheaParentOrderId);
    }

    if (data?.paymentType === paymentTypeOption?.CASHEA_LINK) {
      formData.append(
        `casheaCustomerIdentification`,
        data?.casheaCustomerIdentification
      );
    }

    return formData;
  };

  const queryCasheaLinkPlan = async (identification) => {
    const response = await casheaLinkService.getPayPlan(
      identification,
      watch('finalPrice')
    );
    if ([200, 201].includes(response.status)) {
      return { ok: true, initial: response?.data?.initial };
    }
    notify(response?.message || 'No se pudo consultar el plan de pago', 'error');
    return { ok: false };
  };

  const confirmCasheaLinkOrder = async (identification, initial) => {
    // A diferencia de los demás tipos de pago, Cashea Link no envía el
    // objeto payments: el pago lo procesa Cashea de forma asíncrona y la
    // orden queda Incompleta hasta que ellos lo confirmen.
    const data = {
      membership: membership?._id,
      paymentType: paymentTypeOption?.CASHEA_LINK,
      casheaCustomerIdentification: identification,
    };
    const formData = appendFile(data);
    const response = await paymentsService.createMembershipPayment(formData);
    if ([200, 201].includes(response.status)) {
      // La orden queda Incompleta hasta que Cashea confirme el pago del cliente,
      // por lo que a diferencia de los demás tipos de pago no se llama updateMembershipStatus
      return { ok: true, data: response?.data };
    }
    notify(response?.message || 'No se pudo crear la orden', 'error');
    return { ok: false };
  };

  const getPaymentMethods = () => {
    productService
      .getPaymentMethods('sales')
      .then((response) => {
        if (response.status === 200) {
          let data = response?.data;
          data = data?.filter(
            (d) => d.name !== paymentMethods?.DÉBITO_INMEDIATO_LINK
          );
          setPaymemtMethodOptions(data);

          if (!saleChannel) {
            response.data = data?.filter(
              (d) => d?.name !== paymentMethods?.PAGO_EN_COMERCIO
            );
          }

          let filtered = data?.filter((method) =>
            [paymentMethods?.CASHEA]?.includes(method?.name)
          );
          setFilteredMethods(filtered);

          // Keep only Bancamiga PM and Transfer
          const PM = [
            paymentMethods.PAGO_MÓVIL,
            paymentMethods.PAGO_MÓVIL_BNC,
            paymentMethods.PAGO_MÓVIL_MERCANTIL,
            paymentMethods.PAGO_MÓVIL_GENERICO,
            paymentMethods.PAGO_MOVIL_BANPLUS,
          ];
          const TRANSFER = [
            paymentMethods.TRANSFERENCIA_MERCANTIL,
            paymentMethods.TRANSFERENCIA_BANESCO,
            paymentMethods.TRANSFERENCIA_BNC,
            paymentMethods.TRANSFERENCIA_BANPLUS,
            paymentMethods.TRANSFERENCIA_GENERICO,
            paymentMethods.BANK_TRANSFER,
          ];
          const CASH = [
            paymentMethods.CASH_BS,
            paymentMethods.CASH,
            paymentMethods.CASH_EUR,
            paymentMethods.CASH_USD,
          ];

          if (!authService?.getUser()) {
            data = data?.filter(
              (d) =>
                ![
                  paymentMethods.CASHEA,
                  ...PM,
                  ...TRANSFER,
                  ...CASH,
                  paymentMethods.RETENCION_IVA,
                  paymentMethods.DEPOSITO_BANCAMIGA,
                  paymentMethods.RETENCION_ISLR,
                  paymentMethods.VENPAY,
                  paymentMethods.PAGO_MÓVIL_R4,
                  paymentMethods.PUNTO_DE_VENTA,
                  paymentMethods.PAGO_DIRECTO,
                  paymentMethods.PAGO_EN_COMERCIO,
                  paymentMethods.VENFLOW,
                ].includes(d?.name)
            );
            setPaymemtMethodOptions(sortPublicPaymentMethods(data));
          } else {
            const noCashea = data?.filter(
              (d) =>
                ![paymentMethods.CASHEA, paymentMethods.C2P_BANCAMIGA].includes(
                  d?.name
                )
            );
            setPaymemtMethodOptions(noCashea);
          }
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch(() => { });
  };

  const validateBancamigaPM = async (index, PMpaymentMethod) => {
    let data = {
      date: watch(`date${index}`)
        ? moment(watch(`date${index}`)).format('YYYY-MM-DD')
        : '',
      bank: watch(`bank${index}`), // Bancamiga by default
      phone: '58' + watch(`phone${index}`),
      reference: watch(`reference${index}`),
      method: PMpaymentMethod?._id,
    };

    return bancamigaService
      .checkPayment(data)
      .then((response) => {
        if (response.status === 200) {
          if (response?.data?.wasFound) {
            return true;
          } else {
            notify(`No se pudo validar el pago movil`, 'error');
            return false;
          }
        } else {
          notify(`${response.message}`, 'error');
          return false;
        }
      })
      .catch(() => { });
  };

  const validateBancamigaC2P = async (index, PMpaymentMethod) => {
    let data = {
      bank: watch(`bank${index}`),
      phone: watch(`phone${index}`),
      identification: watch(`identification`),
      identificationType: watch(`identificationType`),
      otp: watch(`otp`),
      amountBsS: watch(`amountBsS${index}`),
      // amountBsS: 0.1,
    };

    return bancamigaService
      .checkC2P(data)
      .then((response) => {
        if (response.status === 200) {
          if (response?.data?.payId) {
            notify(`pago C2P validado correctamente`, 'success');
            return true;
          } else {
            notify(`No se pudo validar el pago C2P`, 'error');
            return false;
          }
        } else {
          notify(`No se pudo validar el pago. Revise los datos`, 'error');
          return false;
        }
      })
      .catch(() => { });
  };

  const validatePagoMovil = async (params, index, PMpaymentMethod) => {
    let isValid = true;
    if (watch(`phone${index}`)?.length !== 10) {
      setError(`phone${index}`, {
        type: 'custom',
        message: 'Ingrese un numero de telefono valido: Ejemplo: 4143579865',
      });
      return false;
    } else {
      setError(`phone${index}`, { type: 'custom', message: '' });
    }

    for (let i = 0; i < params?.length; i++) {
      if (!watch(`${params[i]}${index}`)) {
        setError(`${params[i]}${index}`, {
          type: 'custom',
          message: 'Obligatorio',
        });
        isValid = false;
      }
    }

    if (!authService?.getUser()) {
      // Validate PM against bancamiga API
      let validPM = [paymentMethods?.C2P_BANCAMIGA]?.includes(
        PMpaymentMethod?.name
      )
        ? await validateBancamigaC2P(index, PMpaymentMethod)
        : [paymentMethods?.PAGO_MÓVIL_BANCAMIGA]?.includes(
          PMpaymentMethod?.name
        )
          ? await validateBancamigaPM(index, PMpaymentMethod)
          : null;

      if (!validPM) {
        return false;
      }
    }

    return isValid;
  };

  const acceptPayment = async () => {
    let PMpaymentMethod = filterById(
      paymemtMethodOptions,
      watch('paymentOption')
    );

    // Validate PM and transfer ref length
    if (!validateReferenceLength(PMpaymentMethod, payment)) {
      return null;
    }
    // IF the payment is made in CASH then set the ref message
    for (let i = 0; i < payment?.methods?.length; i++) {
      if ([paymentMethods.CASH_BS].includes(payment?.methods[i]?.name)) {
        setValue(`reference${payment?.paymentNumber}`, 'PAGO EFECTIVO');
      }
    }

    if ([paymentMethods?.NATIONAL_TDC]?.includes(PMpaymentMethod?.name)) {
      if (
        !watch(`identification${payment?.paymentNumber}`) ||
        !watch(`identificationType${payment?.paymentNumber}`) ||
        !watch(`cvc${payment?.paymentNumber}`) ||
        !watch(`cardDate${payment?.paymentNumber}`) ||
        !watch(`card${payment?.paymentNumber}`)
      ) {
        notify(
          'Por favor ingrese todos los datos solicitados para continuar',
          'error'
        );
        return null;
      }

      if (watch(`amount${payment?.paymentNumber}`) > watch(`amountBsS${payment?.paymentNumber}`)) {
        notify('El monto en Dolares no puede ser mayor al monto en BsS', 'error');
        return null;
      }

      if (watch(`amountBsS${payment?.paymentNumber}`) !== (watch(`amount${payment?.paymentNumber}`) * dollarRateByDate).toFixed(2)) {
        notify('El monto en BsS no coincide con el monto en Dolares convertido', 'error');
        return null;
      }
    }

    const params = ['phone', 'bank', 'date'];

    // Valida los Pago movil de bancamigasolamente
    if (
      [
        paymentMethods?.PAGO_MÓVIL_BANCAMIGA,
        paymentMethods?.C2P_BANCAMIGA,
      ]?.includes(PMpaymentMethod?.name)
    ) {
      const isPMValid = await validatePagoMovil(
        params,
        payment?.paymentNumber,
        PMpaymentMethod
      );
      if (!isPMValid) {
        return null;
      }
    }

    // Validate If first Image is Up
    if (
      [paymentMethods.C2P_BANCAMIGA].includes(payment?.methods[0]?.name) &&
      ![
        paymentMethods.PUNTO_DE_VENTA,
        paymentMethods.NATIONAL_TDC,
        paymentMethods.TDC,
      ]?.includes(payment?.methods[0]?.name) &&
      ((!watch(`reference${payment?.paymentNumber}`) &&
        !isPaymentMethodZelleOrPaypal(
          watch(`method${payment?.paymentNumber}`),
          paymemtMethodOptions
        )) ||
        !fileUploaded[payment?.paymentNumber])
    ) {
      notify('Subir imagen y datos de referencia de pago', 'error');
      return null;
    }

    setSelectedMethod('');

    calculateCashBack(payment?.paymentNumber);

    setPayment((prevState) => {
      return {
        ...prevState,
        isOpen: false,
        methods: [],
        paymentNumber: '',
        reference: '',
        selectedMembership: watch('selectedMembership')
          ? selectedMembership
          : '',
      };
    });
  };

  const requestOtTP = async () => {
    if (!isLoading) {
      let data = {
        amount: payment?.amount,
        documentType: watch(`identificationType${payment?.paymentNumber}`),
        documentNumber: watch(`identification${payment?.paymentNumber}`),
        bankCode: watch(`bank${payment?.paymentNumber}`),
        number: watch(`phone${payment?.paymentNumber}`),
      };

      if (!validateInmediateDebit(notify, watch, payment)) {
        return null;
      }

      setIsloading(true);
      bancamigaService
        .sypagoOtp(data)
        .then((response) => {
          if (response.status === 200) {
            notify(`Codigo OTP enviado a ${data.number}`, 'success');
            setValue(`requestedOtp${payment?.paymentNumber}`, true);
            setIsloading(false);
          } else {
            setIsloading(false);

            notify(`${response.message}`, 'error');
          }
        })
        .catch(() => {
          setIsloading(false);
        });
    }
  };

  const successfulStripe = () => {
    setValue(`reference${stripeModal.paymentNumber}`, 'PAGO REALIZADO');

    setStripeModal((prevState) => {
      return {
        ...prevState,
        isOpen: !stripeModal?.isOpen,
        methods: [],
        amount: 0,
        paymentNumber: '',
        selectedMembership: '',
      };
    });
  };

  const handleStipeModal = (amount, paymentNumber) => {
    let selectedPaymentMethods = paymemtMethodOptions.filter(
      (p) => p.name === paymentMethods?.STRIPE
    );

    setStripeModal((prevState) => {
      return {
        ...prevState,
        isOpen: !stripeModal?.isOpen,
        methods: selectedPaymentMethods,
        paymentNumber:
          paymentNumber || paymentNumber === 0 ? paymentNumber : '',
        amount: amount ? amount : 0,
        amountBsS: amount ? amount * dollarRateByDate : 0,
        selectedMembership: watch('selectedMembership')
          ? selectedMembership
          : '',
      };
    });
  };

  const openNewStripeModal = (amount, paymentNumber, igtf) => {
    let data = {
      amount: amount,
      membership: membership?._id,
      paymentType: watch('paymentType'),
      igtf: igtf,
    };

    stripeService
      .paymentIntent(data)
      .then((response) => {
        if (response.status === 200) {
          setClientSecret(response?.data?.clientSecret);
          handleStipeModal(amount, paymentNumber);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch(() => { });
  };

  const preloadValues = () => {
    setValue('finalPrice', membership?.priceInfo?.finalPrice);
    setValue(
      'selectedMembership',
      capitalize(displayMembershipCode(selectedMembership?.code))
    );
    setValue(
      'finalPriceInBsS',
      membership?.priceInfo?.finalPriceInBsS?.toFixed(2)
    );
  };

  const selectUniquePayment = () => {
    // Set Transaction amount depending on the payment type
    if (watch('paymentType') === paymentTypeOption?.DE_CONTADO) {
      setValue('billAmount', membership?.priceInfo?.finalPrice);
    }

    // Preload Payment Methods and amounts
    if (parseFloat(watch('paymentMethodsQuantity')) === 1) {
      setValue('method0', '');
      setValue('amount0', watch('billAmount'));
      handleAmountChange('0');
    } else {
      for (let i = 0; i < parseFloat(watch('paymentMethodsQuantity')); i++) {
        setValue(`method${i}`, '');
        setValue(`amount${i}`, 0);
        handleAmountChange(i);
      }
    }
  };

  const handleBillAmountChange = () => {
    const paymentMethodsQuantity = parseFloat(watch('paymentMethodsQuantity'));

    let acumulated = 0;
    let finalPrice = parseFloat(watch('finalPrice'));
    let billAmount = parseFloat(watch('billAmount'));

    const amount = parseFloat((billAmount / paymentMethodsQuantity).toFixed(2));

    for (let i = 0; i < paymentMethodsQuantity; i++) {
      acumulated = acumulated + amount;
      setValue(`amount${i}`, amount.toFixed(2));

      if (i === paymentMethodsQuantity - 1) {
        // Calcula el residuo de la division y sumalo
        const rest = billAmount - acumulated;
        setValue(`amount${i}`, (amount + rest).toFixed(2));
      }
      setValue(
        `amountBsS${i}`,
        (parseFloat(watch(`amount${i}`)) * rate).toFixed(2)
      );
    }

    if (watch('paymentType') === paymentTypeOption?.FINANCIADO) {
      setValue('financialAmount0', finalPrice - billAmount);
      setValue(
        'financialAmountBsS0',
        (parseFloat(watch('financialAmount0')) * dollarRate).toFixed(2)
      );
    }
  };

  const calculateCashBack = (paymentNumber) => {
    const paymentMethodsQuantity = NaNtoNumber(watch('paymentMethodsQuantity'));
    if (paymentNumber !== paymentMethodsQuantity - 1) {
      return null;
    }

    let totalPaid = 0;
    let totalCashPaid = 0;
    let totalAmount = 0;

    for (let i = 0; i < paymentMethodsQuantity; i++) {
      totalAmount =
        totalAmount + NaNtoNumber(parseFloat(watch(`finalAmount${i}`)));
      totalCashPaid =
        totalCashPaid + NaNtoNumber(parseFloat(watch(`paid${i}`)));
      totalPaid =
        totalPaid +
        (NaNtoNumber(parseFloat(watch(`paid${i}`))) > 0
          ? NaNtoNumber(parseFloat(watch(`paid${i}`)))
          : NaNtoNumber(parseFloat(watch(`finalAmount${i}`))));
    }

    let amountReturned = totalPaid - totalAmount;

    if (amountReturned > 0) {
      setValue('paid', totalCashPaid);
      setValue('paidBsS', (parseFloat(watch('paid')) * dollarRate)?.toFixed(2));
      setValue('amountReturned', amountReturned.toFixed(2));
      setValue('amountReturnedBsS', (amountReturned * dollarRate).toFixed(2));
      setValue('cashbackMethodsQuantity', 1);
      setValue(`returnedAmount0`, Math.abs(amountReturned));
      setValue(
        `returnedAmountBsS0`,
        (parseFloat(watch('amountReturned')) * dollarRate)?.toFixed(2)
      );
    }
  };

  const handleCashbackBs = (index) => {
    let cashbackMethodsQuantity = parseFloat(watch('cashbackMethodsQuantity'));
    let amountReturned = parseFloat(watch(`amountReturned`));

    setValue(
      `returnedAmountBsS${index}`,
      (parseFloat(watch(`returnedAmount${index}`)) * rate)?.toFixed(2)
    );

    // Automatically set the amount for the last method
    if (index === cashbackMethodsQuantity - 2) {
      let paid = 0;
      for (let i = 0; i < cashbackMethodsQuantity - 1; i++) {
        paid = paid + parseFloat(watch(`returnedAmount${i}`));
      }
      if (amountReturned - paid <= 0) {
        notify(
          'La suma de los montos no puede superar el vuelto a entregar',
          'error'
        );
        for (let j = 0; j < cashbackMethodsQuantity; j++) {
          setValue(`returnedAmount${j}`, 0);
          setValue(`returnedAmountBsS${j}`, 0);
        }
        return null;
      }

      setValue(
        `returnedAmount${cashbackMethodsQuantity - 1}`,
        (amountReturned - paid)?.toFixed(2)
      );
      setValue(
        `returnedAmountBsS${cashbackMethodsQuantity - 1}`,
        (
          parseFloat(watch(`returnedAmount${cashbackMethodsQuantity - 1}`)) *
          dollarRate
        )?.toFixed(2)
      );
    }
  };

  const handleCashbackMethodsQuantity = () => {
    for (let i = 0; i < 3; i++) {
      setValue(`returnedMethod${i}`, '');
      setValue(`returnedAmount${i}`, '');
      setValue(`returnedAmountBsS${i}`, '');
      setValue(`cashBackphone${i}`, '');
      setValue(`cashBackbank${i}`, '');
      setValue(`cashBackIdentificationType${i}`, '');
      setValue(`cashBackIdentification${i}`, '');
      setCashBackImage((prevState) => {
        return {
          ...prevState,
          [`image${i}`]: '',
        };
      });
    }

    if (watch('cashbackMethodsQuantity') === '1') {
      setValue(`returnedAmount0`, watch('amountReturned'));
      setValue(
        `returnedAmountBsS0`,
        (parseFloat(watch('amountReturned')) * dollarRate)?.toFixed(2)
      );
    }
  };

  const setPaymentType = () => {
    let paymentType = watch('paymentType');
    if ([paymentTypeOption?.DE_CONTADO].includes(paymentType)) {
      setValue('amount0', membership?.priceInfo?.finalPrice);
      setValue(
        'amountBsS0',
        membership?.priceInfo?.finalPriceInBsS?.toFixed(2)
      );
      setValue('paymentMethodsQuantity', '1');
      setValue('billAmount', membership?.priceInfo?.finalPrice);
    }

    if (paymentType === paymentTypeOption?.FINANCIADO) {
      setValue('paymentMethodsQuantity', '1');
      setValue('billAmount', '');
    }

    if ([paymentTypeOption?.CASHEA].includes(paymentType)) {
      setValue('paymentMethodsQuantity', '1');
      setValue('billAmount', '');
      setValue('initial', '');
      setValue('numCasheaDues', '');
    }
  };

  const validateButtonName = () => {
    let label = 'Siguiente';
    let action = onSubmit;

    if (
      [paymentTypeOption?.COURTESY, paymentTypeOption?.PENDING].includes(
        watch('paymentType')
      )
    ) {
      label = `Registrar pago ${watch('paymentType')}`;
      action = specialPayment;
      return <ActionButton label={label} action={action} />;
    }

    // Con inicial 0 en Cashea no hay referencia ni comprobante de pago,
    // solo se exige la referencia de Cashea
    if (isZeroInitialCashea) {
      return watch('referenceCashea') ? (
        <ActionButton label={label} action={action} />
      ) : null;
    }

    const lastIndex = parseFloat(watch('paymentMethodsQuantity')) - 1;

    if (
      ![
        paymentMethods?.DEBITO_INMEDIATO,
        paymentMethods?.C2P_BANCAMIGA,
        paymentMethods?.NATIONAL_TDC,
      ].includes(
        filterById(paymemtMethodOptions, watch(`method${lastIndex}`))?.name
      ) &&
      !watch(`reference${lastIndex}`) &&
      !fileUploaded[lastIndex]
    ) {
      return null;
    }

    if (
      [paymentMethods?.C2P_BANCAMIGA].includes(
        filterById(paymemtMethodOptions, watch(`method${lastIndex}`))?.name
      ) &&
      !watch(`otp`)
    ) {
      return null;
    }

    return <ActionButton label={label} action={action} />;
  };

  const cancelPayment = (paymentNumber) => {
    let images = [...fileUploaded];
    images[paymentNumber] = '';
    // Remove image if not edit
    if (!payment?.isEdit) {
      setValue(`reference${paymentNumber}`, '');
      setValue(`transactionBatch${paymentNumber}`, '');
      setFileUploaded(images);
    }

    setPayment((prevState) => {
      return {
        ...prevState,
        isOpen: false,
        methods: [],
        paymentNumber: paymentNumber,
        reference: '',
        owner: '',
      };
    });
  };

  const denyIGTFMultipleMethod = () => {
    let methods = paymemtMethodOptions.filter(
      (p) => p.name === showIGTFPaymentModal?.method
    );

    setShowIGTFPaymentModal((prevState) => {
      return {
        ...prevState,
        isOpen: false,
        method: '',
        amount1: 0,
      };
    });

    if (
      [paymentMethods?.TDC]?.includes(methods[0]?.name) &&
      !authService?.getUser()
    ) {
      const igtf = false;
      openNewStripeModal(parseFloat(watch('amount1')), 1, igtf);
    } else {
      setPayment((prevState) => {
        return {
          ...prevState,
          isOpen: true,
          methods: methods,
          paymentNumber: 1,
          amount: parseFloat(watch('amount1')),
          amountBsS: parseFloat(watch('amountBsS1')),
          selectedMembership: watch('selectedMembership')
            ? selectedMembership
            : '',
        };
      });
    }

    setValue('paymentMethodsQuantity', '2');
    setValue(
      'amount1_2IGTF',
      ((watch('amount1') * returnIGTF()) / 100).toFixed(2)
    );
  };

  const denyIGTFSingleMethod = () => {
    let methods = paymemtMethodOptions.filter(
      (p) => p.name === showIGTFPaymentModal?.method
    );

    // Close IGTF Modal
    setShowIGTFPaymentModal((prevState) => {
      return {
        ...prevState,
        isOpen: false,
        method: '',
        amount1: 0,
      };
    });

    if (
      [paymentMethods?.TDC]?.includes(methods[0]?.name) &&
      !authService?.getUser()
    ) {
      const igtf = false;
      openNewStripeModal(watch('amount1'), 1, igtf);
    } else {
      setPayment((prevState) => {
        return {
          ...prevState,
          isOpen: true,
          methods: methods,
          paymentNumber: 1,
          amount: parseFloat(watch('amount1')),
          amountBsS: parseFloat(watch('amountBsS1')),
          selectedMembership: watch('selectedMembership')
            ? selectedMembership
            : '',
        };
      });
    }

    setValue('paymentMethodsQuantity', '2');
    setValue('amount2', ((watch('amount1') * returnIGTF()) / 100).toFixed(2));
    setValue(
      'amountBsS2',
      ((watch('amountBsS1') * returnIGTF()) / 100).toFixed(2)
    );
    setValue(
      'amount1_2IGTF',
      ((watch('amount1') * returnIGTF()) / 100).toFixed(2)
    );
  };

  // Close IGTF modal and open the payment modal with the amout without the tax
  const denyIGTFMethod = () => {
    if (watch('mix')) {
      denyIGTFMultipleMethod();
    } else {
      denyIGTFSingleMethod();
    }
  };

  const acceptIGTFMethod = () => {
    let [selectedMethod] = paymemtMethodOptions.filter(
      (p) => p?._id === watch('method1')
    );
    setValue(
      'amount1IGTF',
      ((watch('amount1') * returnIGTF()) / 100).toFixed(2)
    );

    // Calculate amount
    let amount = parseFloat((watch('amount1') * (100 + returnIGTF())) / 100);

    if (
      selectedMethod?.name === paymentMethods?.TDC &&
      !authService?.getUser()
    ) {
      const igtf = true;
      openNewStripeModal(amount, 1, igtf);
    } else {
      // Maybe set the amoutnt with IGTF ont the payment section
      // Open Payment modal with IGTF included
      setPayment((prevState) => {
        return {
          ...prevState,
          isOpen: true,
          paymentNumber: 1,
          amount: amount,
          amountBsS: parseFloat(watch('amountBsS1')),
          methods: [selectedMethod],
          selectedMembership: watch('selectedMembership')
            ? selectedMembership
            : '',
        };
      });
    }
    // CLose IGTF payment modal
    setShowIGTFPaymentModal((prevState) => {
      return {
        ...prevState,
        isOpen: false,
        method: '',
        amount1: 0,
      };
    });
  };

  const closeIGTFMessageModal = () => {
    setShowIGTFPaymentModal((prevState) => {
      return {
        ...prevState,
        isOpen: false,
      };
    });
  };

  const handleReferenceChange = (e) => {
    const { value } = e?.target;
    setPayment((prevState) => {
      return {
        ...prevState,
        reference: value,
      };
    });

    setValue(`reference${payment?.paymentNumber}`, value);
  };

  const handleOwnerChange = (e) => {
    const { value } = e?.target;
    setPayment((prevState) => {
      return {
        ...prevState,
        owner: value,
      };
    });

    setValue(`owner${payment?.paymentNumber}`, value);
  };

  const handleCasheaInitial = (e) => {
    let billAmount = parseFloat(watch(`initial`));
    let paymentMethodsQuantity = parseFloat(watch('paymentMethodsQuantity'));

    setValue('billAmount', billAmount.toFixed(2));

    if (paymentMethodsQuantity === 1) {
      setValue('amount0', watch('billAmount'));
      setValue('amountBsS0', (watch('amount0') * dollarRateByDate).toFixed(2));
    }

    // Cantidad de metodos de pago = 0
    setValue('numCasheaDues', '');
  };

  const handleCasheaQuotas = () => {
    const initial = parseFloat(watch(`initial`));
    const finalPrice = parseFloat(watch(`finalPrice`));
    const numCasheaDues = parseFloat(watch(`numCasheaDues`));
    const remaining = finalPrice - initial;

    for (let i = 0; i < numCasheaDues; i++) {
      setValue(`method${i}`, '');
      setValue(`financialAmount${i}`, (remaining / numCasheaDues).toFixed(2));
      setValue(
        `financialAmountBsS${i}`,
        (watch(`financialAmount${i}`) * dollarRate).toFixed(2)
      );
    }
  };

  const handleAmountChangeBs = (index) => {
    setValue(
      `amount${index}`,
      NaNtoNumber(
        parseFloat(watch(`amountBsS${index}`)) / dollarRateByDate
      ).toFixed(2)
    );

    const paymentMethodsQuantity = parseFloat(watch('paymentMethodsQuantity'));

    let acumulatedAmount = 0;

    for (let i = 0; i < paymentMethodsQuantity; i++) {
      if (i !== index + 1) {
        acumulatedAmount = acumulatedAmount + parseFloat(watch(`amount${i}`));
      }
    }
    const nextAmount = parseFloat(watch('billAmount') - acumulatedAmount);

    if (nextAmount > 0) {
      setValue(`amount${index + 1}`, nextAmount.toFixed(2));
      setValue(
        `amountBsS${index + 1}`,
        (watch(`amount${index + 1}`) * dollarRateByDate).toFixed(2)
      );
      calculateIGTF(index + 1);
    }

    // Calculate IGTF
    calculateIGTF(index);
    calculateIGTFTotal();
  };

  // New Logic
  const handleAmountChange = (index) => {
    const paymentMethodsQuantity = parseFloat(watch('paymentMethodsQuantity'));

    let acumulatedAmount = 0;

    for (let i = 0; i < paymentMethodsQuantity; i++) {
      if (i !== index + 1) {
        acumulatedAmount = acumulatedAmount + parseFloat(watch(`amount${i}`));
      }
    }
    const nextAmount = parseFloat(watch('billAmount') - acumulatedAmount);

    if (nextAmount > 0) {
      setValue(`amount${index + 1}`, nextAmount.toFixed(2));
      setValue(
        `amountBsS${index + 1}`,
        (watch(`amount${index + 1}`) * dollarRateByDate).toFixed(2)
      );
      calculateIGTF(index + 1);
    }

    // Calculate IGTF
    setValue(
      `amountBsS${index}`,
      NaNtoNumber(
        parseFloat(watch(`amount${index}`)) * dollarRateByDate
      ).toFixed(2)
    );
    calculateIGTF(index);
    calculateIGTFTotal();
  };

  const handleIGTFChange = (index) => {
    const paymentMethodsQuantity = parseFloat(watch('paymentMethodsQuantity'));
    if (index < paymentMethodsQuantity) {
      let acumulatedIGTF = 0;
      // alculate next amount
      for (let i = 0; i < paymentMethodsQuantity; i++) {
        if (i !== index + 1) {
          acumulatedIGTF = acumulatedIGTF + parseFloat(watch(`IGTF${i}`));
        }
      }
      const nextIGTF = parseFloat(watch('totalIGTF') - acumulatedIGTF);

      if (nextIGTF > 0) {
        setValue(`IGTF${index + 1}`, nextIGTF.toFixed(2));
      }

      // Calculate final amount with IGTF in $ and BS
      for (let j = 0; j < paymentMethodsQuantity; j++) {
        setValue(
          `finalAmount${j}`,
          (
            parseFloat(watch(`amount${j}`)) + parseFloat(watch(`IGTF${j}`))
          ).toFixed(2)
        );
        setValue(
          `finalAmountBsS${j}`,
          (parseFloat(watch(`finalAmount${j}`)) * dollarRateByDate).toFixed(2)
        );
      }
    }
  };

  const calculateIGTFTotal = () => {
    let totalIGTF = 0;

    for (let i = 0; i < watch('paymentMethodsQuantity'); i++) {
      const method = filterById(paymemtMethodOptions, watch(`method${i}`));
      if (method && !['BsS'].includes(method.currency)) {
        totalIGTF = totalIGTF + parseFloat(watch(`amount${i}`));
      }
      setValue('totalIGTF', ((totalIGTF * returnIGTF()) / 100)?.toFixed(2));
    }
  };

  const calculateIGTF = (index) => {
    const method = filterById(paymemtMethodOptions, watch(`method${index}`));
    // Calculate IGTF
    if (method && !['BsS'].includes(method.currency)) {
      setValue(
        `IGTF${index}`,
        (watch(`amount${index}`) * (returnIGTF() / 100)).toFixed(2)
      );
    } else {
      setValue(`IGTF${index}`, 0);
    }
    const finalAmount =
      parseFloat(watch(`amount${index}`)) + parseFloat(watch(`IGTF${index}`));
    setValue(`finalAmount${index}`, NaNtoNumber(finalAmount).toFixed(2));
    setValue(
      `finalAmountBsS${index}`,
      parseFloat(watch(`IGTF${index}`)) > 0
        ? authService.getUser()
          ? (NaNtoNumber(finalAmount) * dollarRateByDate).toFixed(2)
          : (NaNtoNumber(finalAmount) * dollarRate).toFixed(2)
        : watch(`amountBsS${index}`)
    );
  };

  const handleMethodChange = (index) => {
    calculateIGTF(index);
    calculateIGTFTotal();
    setValue(`reference${index}`, '');
    setValue(`transactionBatch${index}`, '');
    setValue(`skipApiValidationError${index}`, false);
    setValue(`bank${index}`, '');
    setValue(`phone${index}`, '');
    setValue(`date${index}`, '');

    let images = [...fileUploaded];

    images[index] = '';
    setFileUploaded(images);
  };

  // Payment modal Logix
  const handlePaymentModal = (paymentNumber) => {
    const method = filterById(
      paymemtMethodOptions,
      watch(`method${paymentNumber}`)
    );

    if (method.name === paymentMethods.STRIPE && !authService?.getUser()) {
      openNewStripeModal(
        parseFloat(watch(`finalAmount${paymentNumber}`)),
        paymentNumber,
        false
      );
    } else {
      setValue('paymentOption', method._id);
      setPayment((prevState) => {
        return {
          ...prevState,
          isOpen: true,
          isEdit:
            watch(`reference${paymentNumber}`) || fileUploaded[paymentNumber]
              ? true
              : false,
          amount: parseFloat(watch(`finalAmount${paymentNumber}`)),
          amountBsS: parseFloat(watch(`finalAmountBsS${paymentNumber}`)),
          methods: [method],
          paymentNumber: paymentNumber,
          reference: watch(`reference${paymentNumber}`),
          owner: watch(`owner${paymentNumber}`),
          selectedMembership: watch('selectedMembership')
            ? selectedMembership
            : '',
        };
      });
    }
  };

  const validateIfCanPay = (index) => {
    const paymentMethodsQuantity = parseFloat(watch('paymentMethodsQuantity'));

    const billAmount = parseFloat(watch('billAmount'));
    const totalIGTF = parseFloat(watch('totalIGTF'));

    let accumulatedAmount = 0;
    let accumulatedIGTF = 0;
    for (let i = 0; i < paymentMethodsQuantity; i++) {
      accumulatedAmount = accumulatedAmount + parseFloat(watch(`amount${i}`));
      accumulatedIGTF = accumulatedIGTF + parseFloat(watch(`IGTF${i}`));

      if (!watch(`method${i}`)) {
        return false;
      }
    }

    if (authService.getUser()) {
      return validatePaymentDifference(accumulatedAmount, billAmount);
    }

    if (
      accumulatedAmount !== billAmount ||
      parseFloat(accumulatedIGTF.toFixed(2)) !== totalIGTF
    ) {
      return false;
    }

    // First payment mus be executed before enabiling other buttons
    if (
      ![paymentMethods?.C2P_BANCAMIGA].includes(
        filterById(paymemtMethodOptions, watch(`method0`))?.name
      ) &&
      index !== 0 &&
      !watch(`reference${0}`) &&
      !fileUploaded[0]
    ) {
      return false;
    } else return true;
  };

  const multiplePaymentsTable = {
    header: multiplePaymentsTableHeader,
    validation: { validateIfCanPay: validateIfCanPay },
    fileUploaded: fileUploaded,
    action: { handlePaymentModal: handlePaymentModal },
    onChange: {
      handleAmountChange: handleAmountChange,
      handleAmountChangeBs: handleAmountChangeBs,
      handleMethodChange: handleMethodChange,
      handleIGTFChange: handleIGTFChange,
    },
    dollarRate: rate,
    options: { paymemtMethodOptions: paymemtMethodOptions },
    watch,
    register,
    handleSubmit,
    errors,
    label: true,
    responsive: true,
  };

  const nextQuotaTable = {
    header: nextQuotaTableHeader,
    watch,
    register,
    errors,
    paymentDate: paymentDate,
    options: {
      secondQuotaTime: secondQuotaTime,
      casheaQuotaTime: casheaQuotaTime,
    },
    label: true,
  };

  const openPopupWindow = () => {
    const paramsToSend = {
      identification: watch('casheaUserIdentification'),
      invoiceId: membership?.membershipId.toString(),
      productId: membership?.membershipId.toString(),
      sku: membership?._id.toString(),
      price: watch('finalPrice'),
    };
    const encodedParams = encodeURIComponent(JSON.stringify(paramsToSend));
    const popupUrl = `/cashea-confirmation?params=${encodedParams}`; // O la URL de tu componente hijo

    const newWindow = window.open(
      popupUrl,
      '_blank',
      'width=800,height=600,scrollbars=yes'
    );
    setPopupWindow(newWindow);
    setIsloading(true);
  };

  useEffect(() => {
    let popupChecker;

    const handleStorage = (event) => {
      // Solo procesa si la clave es 'casheaResult' y hay datos nuevos
      if (event.key === 'casheaResult' && event.newValue) {
        const data = JSON.parse(event.newValue);
        setValue('casheaParentOrderId', data.casheaParentOrderId);
        setValue('casheaOrderId', data.casheaOrderId);
        setValue('casheaDownPayment', data.casheaDownPayment);
        setValue('billAmount', data.casheaDownPayment);
        setValue('amount0', data.casheaDownPayment);
        setValue(
          'amountBsS0',
          (data.casheaDownPayment * dollarRate).toFixed(2)
        );
        setValue('finalAmount0', data.casheaDownPayment);
        setValue(
          'finalAmountBsS0',
          (data.casheaDownPayment * dollarRate).toFixed(2)
        );
        setValue('referenceCashea', data.casheaOrderId);
        setValue('initial', data.casheaDownPayment);

        setValue(
          'financialAmount0',
          ((watch('finalPrice') - Number(data.casheaDownPayment)) / 3).toFixed(
            2
          )
        );
        setValue(
          'financialAmount1',
          ((watch('finalPrice') - Number(data.casheaDownPayment)) / 3).toFixed(
            2
          )
        );
        setValue(
          'financialAmount2',
          ((watch('finalPrice') - Number(data.casheaDownPayment)) / 3).toFixed(
            2
          )
        );
        setValue(
          'financialAmountBsS0',
          (
            ((watch('finalPrice') - Number(data.casheaDownPayment)) / 3) *
            dollarRate
          ).toFixed(2)
        );
        setValue(
          'financialAmountBsS1',
          (
            ((watch('finalPrice') - Number(data.casheaDownPayment)) / 3) *
            dollarRate
          ).toFixed(2)
        );
        setValue(
          'financialAmountBsS2',
          (
            ((watch('finalPrice') - Number(data.casheaDownPayment)) / 3) *
            dollarRate
          ).toFixed(2)
        );

        setValue('casheaUserIdentification', '');
        setIsloading(false);
        localStorage.removeItem('casheaResult');
        if (popupChecker) clearInterval(popupChecker);
      }
    };

    window.addEventListener('storage', handleStorage);

    if (popupWindow) {
      popupChecker = setInterval(() => {
        if (popupWindow.closed) {
          setValue('casheaUserIdentification', '');
          setIsloading(false);
          clearInterval(popupChecker);
        }
      }, 1000);
    }

    return () => {
      window.removeEventListener('storage', handleStorage);
      if (popupWindow && !popupWindow.closed) {
        popupWindow.close();
      }
    };
  }, [popupWindow, dollarRate, setValue, watch]);

  const multipleClientsTable = {
    header: multipleVehiclesTableHeader,
    data: membershipList,
    curentStep: curentStep,
  };

  const shouldDisableReferenceAndReceipt = (paymentMethod) => {
      const role = authService?.getUserType();
      const hunter = salesRoles.SALES_HUNTER;
      const farmer = salesRoles.SALES_FARMER;
      const counter = salesRoles.SALES_COUNTER;
  
      const notAllowedRoles = [hunter, farmer, counter];
  
      // Nombres de métodos de pago a bloquear
      const blockedMethodNames = [
        'PAGO MÓVIL BANCAMIGA',
        'PAGO MÓVIL BNC',
        'PAGO MÓVIL MERCANTIL',
        'PAGO MÓVIL BANESCO',
        'PAGO MOVIL BANPLUS',
        'PAGO MÓVIL GENERICO',
        'PAGO MÓVIL',
        'C2P BANCAMIGA',
        'TRANSFERENCIA BANCAMIGA',
        'TRANSFERENCIA BNC',
        'TRANSFERENCIA MERCANTIL',
        'TRANSFERENCIA BANESCO',
        'TRANSFERENCIA BANPLUS',
        'TRANSFERENCIA GENERICO',
        'BANK TRANSFER',
        'ZELLE',
        'PAYPAL',
        'BINANCE',
      ];
      const selectedMethod = paymemtMethodOptions.find((p) => p._id === paymentMethod);
      const isBlocked = selectedMethod 
        ? blockedMethodNames.includes(selectedMethod.name) 
        : blockedMethodNames.includes(paymentMethod);
  
      // Si el rol es hunter, farmer o counter (interno o externo)
      // y el método de pago es uno de los bloqueados
      if (
        notAllowedRoles.includes(role?.code || role) &&
        isBlocked
      ) {
        return true;
      }
      return false;
    };

  useEffect(() => {
    setValue('mix', false);
    validatePaymentOptions();
    getPaymentMethods();
    preloadValues();
    getCashReceivers();
  }, []);

  useEffect(() => {
    if (
      !authService?.getUser() &&
      [paymentTypeOption?.CASHEA].includes(watch('paymentType'))
    ) {
      setValue('numCasheaDues', 3);
    }
  }, [watch('paymentType')]);

  return (
    <>
      <LoadSpinner show={isLoading} />
      <IGTFPaymentModal
        modal={showIGTFPaymentModal}
        handleModal={closeIGTFMessageModal}
        acceptIGTFMethod={acceptIGTFMethod}
        denyIGTFMethod={denyIGTFMethod}
      />
      <StripeModal
        stripeModal={stripeModal}
        handleStipeModal={handleStipeModal}
        clientSecret={clientSecret}
        successfulStripe={successfulStripe}
        watch={watch}
      />

      <NewPaymentModal
        fileUploaded={fileUploaded}
        setFileUploaded={setFileUploaded}
        cancelPayment={cancelPayment}
        acceptPayment={acceptPayment}
        requestOtTP={requestOtTP}
        selectedMethod={selectedMethod}
        getPaymentsData={getPaymentsData}
        register={register}
        watch={watch}
        dollarRate={dollarRate}
        dollarRateByDate={rate}
        payment={payment}
        showErrorAPI={showErrorAPI}
        errors={errors}
        setValue={setValue}
        control={control}
        cashReceiverOptions={cashReceiverOptions}
        handleReferenceChange={handleReferenceChange}
        handleOwnerChange={handleOwnerChange}
        handleGenericPaymentMethods={handleGenericPaymentMethods}
      />
      <CashbackModal
        cancelPayment={handleCashbackModal}
        acceptPayment={saveCashbackData}
        options={{ paymentMethodOptions: paymemtMethodOptions }}
        register={register}
        errors={errors}
        payment={cashbackModal}
      />
      {membershipList.length > 0 && (
        <MultipleVehiclesTable table={multipleClientsTable} />
      )}
      <div className="landing-form-container">
        <h5>Información del Pago</h5>

        <p>(*) Campos obligatorios</p>
        <br />

        <div className="row">
          <Input
            bootstrap={'col-12 col-md-6'}
            label={'Plan'}
            type={'text'}
            name={'selectedMembership'}
            register={register}
            placeholder={''}
            errors={errors?.selectedMembership?.message}
            disabled={true}
          />{' '}
          <Input
            bootstrap={'col-12 col-md-6'}
            label={'Precio USD'}
            type={'number'}
            name={'finalPrice'}
            register={register}
            placeholder={''}
            errors={errors?.finalPrice?.message}
            disabled={true}
          />{' '}
          <Input
            bootstrap={'col-12 col-md-6'}
            label={'Precio Bs'}
            type={'number'}
            name={'finalPriceInBsS'}
            register={register}
            placeholder={''}
            errors={errors?.finalPriceInBsS?.message}
            disabled={true}
          />{' '}
          {watch('finalPrice') !== 0 && (
            <>
              <Input
                bootstrap={'col-12 col-md-6'}
                label={'Tipo de pago *'}
                type={'select'}
                name={'paymentType'}
                register={register}
                options={paymentTypeVar}
                placeholder={''}
                errors={errors?.paymentType?.message}
                onChange={setPaymentType}
                disabled={watch('reference0') || fileUploaded[0]}
              />
              {![
                paymentTypeOption?.COURTESY,
                paymentTypeOption?.PENDING,
                paymentTypeOption?.CASHEA_LINK,
              ].includes(watch('paymentType')) && (
                  <Input
                    bootstrap={'col-12 col-md-6'}
                    label={'Cantidad de Métodos de pago *'}
                    type={'select'}
                    name={'paymentMethodsQuantity'}
                    register={register}
                    options={paymentMethodsQuantity}
                    capitalizeOff={true}
                    placeholder={''}
                    errors={errors?.paymentMethodsQuantity?.message}
                    onChange={selectUniquePayment}
                    disabled={
                      ([paymentTypeOption?.CASHEA].includes(
                        watch('paymentType')
                      ) &&
                        !authService?.getUser()) ||
                      watch('reference0') ||
                      fileUploaded[0]
                    }
                  />
                )}
              {[paymentTypeOption?.FINANCIADO, paymentTypeOption?.VENFLOW].includes(
                watch('paymentType')
              ) && (
                  <Input
                    bootstrap={'col-12 col-md-6'}
                    label={'Monto inicial *'}
                    type={'number'}
                    name={'billAmount'}
                    register={register}
                    capitalizeOff={true}
                    placeholder={''}
                    errors={errors?.billAmount?.message}
                    onChange={handleBillAmountChange}
                    disabled={watch('reference0') || fileUploaded[0]}
                  />
                )}
            </>
          )}
          {watch('paymentType') === paymentTypeOption?.CASHEA_LINK ? (
            <CasheaLinkFlow
              planName={watch('selectedMembership')}
              priceUSD={watch('finalPrice')}
              priceBs={watch('finalPriceInBsS')}
              membershipId={membership?._id}
              onQueryPlan={queryCasheaLinkPlan}
              onConfirmOrder={confirmCasheaLinkOrder}
              onCancel={() => setValue('paymentType', '')}
              hideSummaryFields
            />
          ) : authService?.getUser() ? (
            <>
              {[paymentTypeOption?.CASHEA].includes(watch('paymentType')) &&
                watch('paymentMethodsQuantity') && (
                  <>
                    <Input
                      bootstrap={'col-12 col-md-6'}
                      label={'Inicial USD *'}
                      type={'number'}
                      name={'initial'}
                      register={register}
                      // options={initialOptions.slice(1)}
                      capitalizeOff={true}
                      placeholder={''}
                      onChange={handleCasheaInitial}
                      disabled={watch('reference0') || fileUploaded[0]}
                      errors={errors?.initial?.message}
                    />
                    {/* <Input
                      bootstrap={'col-12 col-md-6'}
                      label={'Cantidad de Cuotas *'}
                      type={'select'}
                      name={'numCasheaDues'}
                      register={register}
                      options={numCasheaDues}
                      capitalizeOff={true}
                      placeholder={''}
                      onChange={handleCasheaQuotas}
                      disabled={watch('reference0') || fileUploaded[0]}
                      errors={errors?.numCasheaDues?.message}
                    /> */}
                    <Input
                      bootstrap={'col-12 col-md-6'}
                      label={`Referencia Cashea *`}
                      type={'number'}
                      name={`referenceCashea`}
                      register={register}
                      placeholder={''}
                      errors={errors?.[`referenceCashea`]?.message}
                      disabled={watch('reference0') || fileUploaded[0]}
                      min={'0'}
                    />
                  </>
                )}
            </>
          ) : (
            <div
              className="buttons-center-container"
              style={{ margin: '24px 0px 48px 0px' }}
            >
              {[paymentTypeOption?.CASHEA].includes(watch('paymentType')) &&
                !watch('casheaParentOrderId') &&
                watch('paymentMethodsQuantity') && (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Input
                      type={'text'}
                      style={{
                        border: '2px solid #ffa825',
                      }}
                      bootstrap={'col-12 col-md-3'}
                      label={'Cédula de cliente Cashea'}
                      name={'casheaUserIdentification'}
                      register={register}
                      placeholder={''}
                      errors={errors?.casheaUserIdentification?.message}
                    />

                    <ActionButton
                      label={'Continuar con Cashea'}
                      action={() => openPopupWindow()}
                      disabled={!watch('casheaUserIdentification')}
                    />
                  </div>
                )}
            </div>
          )}
        </div>
        {watch('paymentType') !== paymentTypeOption?.CASHEA_LINK && (
          <>
            {!isZeroInitialCashea && (
              <MultiplePaymentsTable table={multiplePaymentsTable} />
            )}

            <NextQuotasTable table={nextQuotaTable} />

            <CashBackComponent
              register={register}
              errors={errors}
              watch={watch}
              options={{
                paymemtMethodOptions: paymemtMethodOptions,
                filteredMethods: filteredMethods,
              }}
              onChange={{
                handleCashbackBs: handleCashbackBs,
                handleCashbackMethodsQuantity: handleCashbackMethodsQuantity,
              }}
              handleCashbackModal={handleCashbackModal}
              handleDrop={handleDrop}
              cashBackImage={cashBackImage}
              removeFile={removeFile}
              errorsDropzone={errorsDropzone}
              shouldDisableReferenceAndReceipt={shouldDisableReferenceAndReceipt}
            />
            <div className="buttons-center-container">
              {watch('paymentMethodsQuantity') && (
                <img className="safePayment" src={safePayment} alt="safePayment" />
              )}
            </div>
            <div
              style={{ margin: '24px 0px 48px 0px' }}
              className="buttons-center-container"
            >
              <AltButton
                label={'Regresar'}
                action={() => setcurentStep(curentStep - 1)}
              />
              {watch('finalPrice') !== 0 && validateButtonName()}
              {watch('finalPrice') === 0 && (
                <ActionButton
                  label={'Continuar'}
                  action={() => updateMembershipStatus(membership?._id)}
                />
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
});
